import { render, staticRenderFns } from "./mcheck.vue?vue&type=template&id=15233814&scoped=true"
import script from "./mcheck.vue?vue&type=script&lang=js"
export * from "./mcheck.vue?vue&type=script&lang=js"
import style0 from "./mcheck.vue?vue&type=style&index=0&id=15233814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15233814",
  null
  
)

export default component.exports